import React, { Component } from "react";
import {Glyphicon, Table, Form, OverlayTrigger} from 'react-bootstrap';
import { WarehouseService } from "../Services/WarehouseService";
import {tooltip} from '../Utils'
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withStyles, Grid, Tooltip, IconButton, Icon } from "@material-ui/core";
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import { RowCountOptions } from "../Config";
import EnhancedTableHead from "../components/EnhancedTableHead";
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { UserService } from "../Services/UserService";
import {Typeahead} from 'react-bootstrap-typeahead';

function getModalStyle() {
    const top = 50 ;
    const left = 50 ;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    margin: {
        margin: theme.spacing(1),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    paper: {
        position: 'absolute',
        width: theme.spacing(50),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
    },
    tablecell: {
        fontSize: '40pt'
    },
    reason_title: {
        fontWeight: "bold"
    },
    row: {
        margin: theme.spacing(1),
    }
  });

class ManageInventoryMaster extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        current_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 1,
        totalPages: 0,
        filter: '',
        new_wh: {name: "", address: "", city: "", state: "", zip: ""},
        show: false,
        columns : [
            { id: 'name', numeric: false, disablePadding: false, label: 'Name' , sortable: true },
            { id: 'address', numeric: false, disablePadding: false, label: 'Address', sortable: true  },
            { id: 'city', numeric: false, disablePadding: false, label: 'City', sortable: true  },
            { id: 'state', numeric: false, disablePadding: false, label: 'State', sortable: true  },
            { id: 'zip', numeric: false, disablePadding: false, label: 'Zip', sortable: true  },
            { id: 'status', numeric: false, disablePadding: false, label: 'Status', sortable: false  },
            { id: 'actions', numeric: false, disablePadding: false, label: 'Actions', sortable: false  },
        ],
        order: 'asc',
        orderBy: 'name',
        master_agents: [],
        reasons_row: [],
        showReason: false,
        selectedAgent: {},
        selectedReason: {},
      }

      this.handleSelect = this.handleSelect.bind(this);
      this.clearSearch = this.clearSearch.bind(this);

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.newWH = this.newWH.bind(this);
      this.createModifyWH = this.createModifyWH.bind(this);
      this.removeWH = this.removeWH.bind(this);
      this.toggleStatus = this.toggleStatus.bind(this);
    }
    componentDidMount(){
        this.props.setTitle('Manage Inventory Master');
        this.props.isLoading(true);
        WarehouseService.getTotalCount("WAREHOUSE")
        .then((data) => {
            console.log(data);
            this.props.isLoading(false);
            this.setState({
                totalItems: data.count, 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            }, () => {
                this.fetchData(0, this.state.numItemsPerPage);
                this.fetchAgents();
            });
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchAgents = () => {
        UserService.getAgentList()
        .then((data) => {
            console.log(data);
            this.setState({master_agents: data.users}, () => this.fetchReasons());
        })
        .catch(error => console.log(error));
    }

    removeOwnership = (e, reason) => {
        e.preventDefault();
        this.props.showConfirmDialog("Confirm removal of ownership?", undefined, () => {
            WarehouseService.removeReasonOwnership(reason.code, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data) => {
                this.props.showSnackBar('Removed Ownership', 'success');
                this.fetchReasons();
            })
            .catch((error) => {
                this.props.showConfirmDialog("Cannot remove ownership. Please try again later.", undefined, undefined);
            });
            this.props.closeConfirmDialog();
        });
    }
    
    removeReason = (e, reason) => {
        this.props.showConfirmDialog("Confirm removal of Reason?", 'Remove', () => {
            WarehouseService.removeReason(reason.code, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data) => {
                this.props.showSnackBar('Removed Reason', 'success');
                this.fetchReasons();
            })
            .catch((error) => {
                this.props.showConfirmDialog("Failed to remove. Please try again later.", undefined, undefined);
            });
            this.props.closeConfirmDialog();
        });
    }

    handleCloseReason = () => {
        this.setState({ showReason: false , selectedAgent: {}, selectedReason: {}});
    }

    handleShowReason = () => {
        this.setState({ showReason: true });
    }
    
    assignOwnership = (e, reason) => {
        this.handleShowReason();
        if(reason.ownership_id){
            let agent = this.state.master_agents.filter((agent) => {
                return agent.id === reason.ownership_id;
            });
            if(agent)
                this.setState({selectedAgent: agent});
        }
        this.setState({selectedReason: reason});
    }

    handleAssignOwnership = () => {
        let body = {
            code: this.state.selectedReason.code, 
            ownership_id: this.state.selectedAgent.id 
        };
        WarehouseService.assignOwnership(body, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
        .then((data) => {
            this.props.showSnackBar('Ownership Assigned', 'success');
            console.log(data);
            this.handleCloseReason();
            this.fetchReasons();
        })
        .catch((error) => {
            console.log(error);
            this.props.showConfirmDialog("Something went wrong. Please check again later.", undefined, undefined);
        });
    }

    fetchReasons = () => {
        WarehouseService.getWarehouseReasons()
        .then(data => {
            console.log(data);
            let classes = this.props.classes;

            let reasons_row = data.reasons.map((reason, i) => {
                let owner = reason.ownership_id && this.state.master_agents.filter(a => a.id === reason.ownership_id)[0].name;
                return (
                <Grid container item xs={12} lg={12} key={i} className={classes.row}>
                    <Grid item xs={1} lg={1}>
                        <Typography variant="body1" style={{lineHeight: 3}}>{i + 1}</Typography>
                    </Grid>
                    <Grid item xs={5} lg={5}>
                        <Typography variant="body1" style={{lineHeight: 3}}>{reason.description}</Typography>
                    </Grid>
                    <Grid item xs={4} lg={3}>
                        <Typography variant="body1" style={{lineHeight: 3}} color={reason.ownership_id ? "secondary" : "primary"}>{reason.ownership_id ? owner : 'Individual'}</Typography>
                    </Grid>
                    <Grid item xs={2} lg={3}>
                        <Tooltip title="Remove Reason">
                            <IconButton aria-label="Remove Reason" onClick={(e) => this.removeReason(e, reason)} >
                                <Icon>delete</Icon>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={reason.ownership_id ? "Reassign" : "Assign"}>
                            <IconButton aria-label={reason.ownership_id ? "Reassign" : "Assign"} onClick={(e) => this.assignOwnership(e, reason)}>
                                <Icon>person</Icon>
                            </IconButton>
                        </Tooltip>
                        { reason.ownership_id ? (
                                <Tooltip title="Remove ownership">
                                    <IconButton aria-label="Remove ownership" onClick={(e) => this.removeOwnership(e, reason)}>
                                        <Icon>cancel</Icon>
                                    </IconButton>
                                </Tooltip>
                            ) : null
                        }
                    </Grid>
                    <Grid item xs={12} lg={12} style={{marginTop: 5}}>
                        <Divider />
                    </Grid>
                </Grid>
            );
            });

            this.setState({master_reasons: data.reasons, reasons_row})
        })
        .catch(error => console.log(error));
    }

    removeWH(e, wh){
        e.preventDefault();
        this.props.showConfirmDialog(`Confirm removal of ${wh.name}?`, undefined, () => {
            let header = {'user-id' : this.props.user.id, 'user-name': this.props.user.name };
            WarehouseService.remove(wh.id, header)
            .then((data) => {
                console.log(data);
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
            })
            .catch(error => {
                console.log(error);
            });
            this.props.closeConfirmDialog();
        });
    }

    toggleStatus(e, wh){
        if(e)
            e.preventDefault();
        WarehouseService.toggleStatus(wh.id)
        .then((data) => {
            console.log(data);
            const status = data.status === "0" ? "Deactivated": "Activated";
            this.props.showSnackBar(`${status} user ${data.name} Account`, 'info');
            this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
        })
        .catch(error => console.log(error));
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(start, numberItems, filter = ''){
        this.props.isLoading(true);
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        WarehouseService.getWarehouseList(start, numberItems, filter, sort, direction)
        .then((data) => {
            console.log(data);
            this.setState({data: data.warehouse, originalData: data.warehouse});
            if(data.warehouse){
                data.warehouse.forEach((wh) => {
                    rows.push(<WarehouseDetails key={wh.id} wh={wh} edit={this.newWH} remove={this.removeWH} toggleStatus={this.toggleStatus}/>);
                });
                this.setState({
                    current_rows: rows
                });
            }
            
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.new_wh;
        change[e.target.name] = e.target.value;
        this.setState({new_wh: change});
    }

    handleChangeNewReason = (e) => {
        e.preventDefault();
        this.setState({new_reason: e.target.value});
    }

    createReason = (e) => {
        e.preventDefault();
        this.props.showConfirmDialog("Confirm create reason?", 'New Reason', () => {
            let body = {reason: this.state.new_reason};
            WarehouseService.createReason(body, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data) => {
                console.log(data);
                this.props.showSnackBar('Reason Created. Now Assign Ownership.', 'success');
                this.setState({
                    new_reason: ""
                });
                this.fetchReasons();
            })
            .catch((error) => {
                console.log(error);
                this.props.showConfirmDialog("Reason already exists. Please check again.", undefined, undefined);
            });
            this.props.closeConfirmDialog();
        });
    }

    newWH(e, wh){
        if(wh) {
            //Add previous contract values to state and populate the form
            this.setState({ new_wh: {id: wh.id, name: wh.name, address: wh.address, city: wh.city, state: wh.state, zip: wh.zip}});
        }
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_wh: {name: "", address: "", city: "", state: "", zip: ""}
        });
    }

    handleShow() {
        this.setState({ show: true });
    }

    createModifyWH(e){
        if(e){
            e.preventDefault();
        }
        let new_wh = this.state.new_wh;
        if(new_wh.name && new_wh.city && new_wh.state && new_wh.zip){
            this.props.showConfirmDialog(`Confirm?`, undefined, () => {
                this.props.isLoading(true);
                WarehouseService.createModify(new_wh, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
                .then((data) => {
                    console.log(data);
                    this.props.isLoading(false);
                    this.handleClose();
                    this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                })
                .catch(error => {
                    this.props.showSnackBar(`Something went wrong. Please try again later.`, 'error');
                    this.props.isLoading(false);
                });
                this.props.closeConfirmDialog();
            });
        } else {
            this.props.showSnackBar('Please fill all the details and continue', 'error');
        }
    }

    clearSearch(e){
        this.refs.inputText.value = "";
        this.setState({filter: ''});
        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
    }

    filterCriteria(e){
        e.preventDefault();
            const searchText = this.refs.inputText.value;
            this.setState({filter: searchText}, () => this.fetchData(0, this.state.numItemsPerPage, searchText));
    }
    
    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage){
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }
    
    render() {
        let {message, reasons_row} = this.state;
        let classes = this.props.classes;
        return (
            <div className="Home" style={{marginTop: 32, paddingTop: 8}}>
                <Grid container>
                    <Grid item xs={12} lg={12}>
                        <Paper>
                        <Typography variant="h6" style={{marginBottom: '20px'}}>Warehouses</Typography>
                        <br />
                        <div>
                            <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                                <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "80%", marginBottom: "10px", marginRight: "10px", padding: "5px", borderColor:"red"}} autoComplete="off">
                                </input>
                                <Glyphicon glyph="remove" onClick={this.clearSearch} style={{marginRight: "20px"}}/>
                            </form>
                        </div>
                        <div>
                                <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                                { !message &&
                                    <div style={{width: "100%", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px"}}>
                                        <Table striped condensed hover responsive>
                                            <EnhancedTableHead
                                                order={this.state.order}
                                                orderBy={this.state.orderBy}
                                                onRequestSort={this.sortBy}
                                                rows ={this.state.columns} />
                                            <TableBody>
                                                {this.state.current_rows}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={RowCountOptions}
                                            component="div"
                                            count={this.state.totalItems}
                                            rowsPerPage={this.state.numItemsPerPage}
                                            page={this.state.currentPageNumber}
                                            backIconButtonProps={{
                                                'aria-label': 'Previous Page',
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'Next Page',
                                            }}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}/>
                                    </div>    
                                }
                                
                        </div>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Paper style={{marginTop: 24, paddingTop: 8}}>
                            <Typography variant="h6" style={{margin: 12}}>Reasons</Typography>
                            <Grid container>
                                <Grid item xs={1} lg={1}>
                                </Grid>
                                <Grid item xs={5} lg={5}>
                                    <Typography variant="body1" className={classes.reason_title}>Reason</Typography>
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <Typography variant="body1" className={classes.reason_title}>Owner</Typography>
                                </Grid>
                                <Grid item xs={2} lg={3}>
                                    <Typography variant="body1" className={classes.reason_title}>Action</Typography>
                                </Grid>
                                {reasons_row}
                                <Grid item xs={12} lg={12}>
                                    <Divider />
                                </Grid>
                                <Grid item container xs={12} lg={12}>
                                    <Grid item xs={12} lg={6}>
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            label="New Reason"
                                            margin="normal"
                                            defaultValue={this.state.new_reason}
                                            name="new_reason"
                                            fullWidth
                                            onChange={this.handleChangeNewReason}
                                            pattern="[0-9]*"
                                            type="text"
                                            required />
                                    </Grid>
                                    <Grid item xs={12} lg={6} style={{marginTop: 24}}>
                                        <Button variant="contained" size="medium" color="primary" type="submit" onClick={this.createReason} autoFocus>Create</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
                <Modal 
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.show} 
                    onClose={this.handleClose}>
                    <div style={getModalStyle()} className={this.props.classes.paper}>
                        <Typography variant="h6" id="modal-title">
                            {this.state.show ? "Warehouse Details" : ""}
                        </Typography>
                        <Divider />
                        {this.whForm(this.createModifyWH, "Save")}
                    </div>
                </Modal>
                <Modal 
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.showReason} 
                    onClose={this.handleCloseReason}>
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography variant="h6" id="modal-title">
                            Assign Ownership
                        </Typography>
                        <Divider />
                        <Typeahead
                            id="typeahead-id-inventory-master"
                            onChange={(selected) => {
                                this.setState({ selectedAgent: selected[0] });
                            }}
                            options={this.state.master_agents}
                            labelKey="name"
                            placeholder="Choose an owner"
                            clearButton
                            //defaultSelected ={this.state.selectedAgent}
                        />
                        <div style={{marginTop: "10px"}}>
                            <Button variant="outlined" size="medium" color="primary" type="submit" onClick={this.handleAssignOwnership} style={{marginRight: "10px"}}>Assign</Button>
                            <Button variant="outlined" size="medium" color="primary" onClick={this.handleCloseReason}>Close</Button>
                        </div>
                    </div>
                </Modal>
                <Fab onClick={this.newWH} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '90%'}}>
                    <AddIcon />
                </Fab>
            </div>
        );
    }

    getValidationStateName() {
        if(this.state.new_wh.name){
            const length = this.state.new_wh.name.length;
            if (length >= 3) return 'success';
            else return 'error';
        }
        return null;
    }

    whForm = (submitFunction, buttonText, orientation) => (
        <Form {...orientation} className="" onSubmit={submitFunction}>
            <TextField
                id="name"
                label="Name"
                placeholder="Name"
                name="name"
                fullWidth
                value={this.state.new_wh.name}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                />
            <TextField
                id="address"
                label="Address"
                placeholder="Address"
                name="address"
                fullWidth
                value={this.state.new_wh.address}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                />
            <TextField
                id="city"
                label="City"
                placeholder="City"
                name="city"
                fullWidth
                value={this.state.new_wh.city}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                />
            <TextField
                id="state"
                label="State"
                placeholder="State"
                name="state"
                fullWidth
                value={this.state.new_wh.state}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                />
            <TextField
                id="zip"
                label="Zip"
                placeholder="Zip"
                name="zip"
                fullWidth
                value={this.state.new_wh.zip}
                className={this.props.classes.textField}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                required
                />
            <div style={{marginTop: "10px", marginLeft: '10px'}}>
                <Button variant="outlined" size="medium" style={{marginRight: "10px"}} onClick={this.handleClose}>Close</Button>
                <Button variant="outlined" size="medium" style={{marginRight: "10px"}} color="primary"  type="submit" onClick={submitFunction} autoFocus>{buttonText}</Button>
            </div>
        </Form>
    )
}

class WarehouseDetails extends Component {

    render(){
      const wh = this.props.wh;
      return (
        <tr className={wh.status === "0" ? "danger" : "success"}>
            <td>{wh.name}</td>
            <td>{wh.address}</td>
            <td>{wh.city}</td>
            <td>{wh.state}</td>
            <td>{wh.zip}</td>
            <td>{wh.status === '1' ? "Active" : "Deactive" }</td>
            <td>
                <Glyphicon style={{marginRight: "10px"}} glyph="pencil" onClick={(e) => this.props.edit(e, wh)}/>
                <OverlayTrigger placement="bottom" overlay={tooltip("Remove Warehouse")}>
                    <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.remove(e, wh)}/>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={tooltip("Activate/Deactivate")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="off" onClick={(e) => this.props.toggleStatus(e, wh)}/>
                </OverlayTrigger>
            </td>
        </tr>
      );
    }
}

export default withStyles(styles)(ManageInventoryMaster);